export default "__VITE_ASSET__1b4ada73__"